import { Injectable } from "@angular/core";
import { AuthenticationService } from "../../core/auth/authentication.service";
import { DataService } from "../../core/data/data.service";

@Injectable()
export class TimeoutManagerService {
    constructor(private authenticationService: AuthenticationService) {}

    public handleTimeoutForDataServices(dataServices: {
        [key: string]: DataService<any>;
    }) {
        for (const dataSourceName of Object.keys(dataServices)) {
            this.handleTimeoutForDataService(dataServices[dataSourceName]);
        }
    }

    public handleTimeoutForDataService(dataService: DataService<any>) {
        dataService.errors.subscribe((errorEvent) => {
            if (
                errorEvent &&
                errorEvent["error"].message == "Error: HTTP Status 401 "
            ) {
                this.handleTimeout();
            }
        });
    }

    public handleTimeout() {
        sessionStorage.removeItem("SupplierApp.autologin");
        sessionStorage.removeItem("SupplierApp.supplierName");
        this.authenticationService.signOut();
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/services/timeout-manager.service.ts